import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useStoreId } from '~/providers/StoreUserProvider';

export const useProductTags = () => {
  const storeId = useStoreId();
  const queryKey = ['product', 'tags', storeId];

  return useQuery({
    queryKey,
    queryFn: () => api.store(storeId).product.tags(),
  });
};
